import React from "react";
import { fileTypes } from "../../../consts/consts";
import UploadFile from "../../UploadFile";
import { fetchData } from "../../Service/graphQlService";
import { GET_FILE_URL } from "../../Graphql/Queries/getFileUrl";

export default class UploadFiles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMaxFiles: 1,
            uploadManually: false,
            items: [],
            filesItem:[],
            urlPath:"",
        };

        this.increaseMaxFiles = this.increaseMaxFiles.bind(this);
        this.resetFilesItem = this.resetFilesItem.bind(this)
        this.getPathData= this.getPathData.bind(this)
    }
    
    componentDidMount() {
        const {items, data, initialFilesAmount} = this.props;
        let fileCount = initialFilesAmount ? initialFilesAmount : items.reduce((count, item) => data[item.name] ? ++count : count, 0)
        this.setState({currentMaxFiles: fileCount || 1})
    }
    componentDidUpdate(prevProps, prevState) {
        const { items, data } = this.props;
        if (Object.keys(data).length && items.length && this.state.filesItem == 0){
            const itemsCopy = [...items]; // Create a new copy of items
            Promise.all(
                items.map(async (item, index) => {
                    if (data[item.name]) {
                        const response = await fetchData(GET_FILE_URL, { id: data[item.name] });
                        if (response.data && response.data.getFile && response.data.getFile.fileUrl) {
                            itemsCopy[index] = { ...itemsCopy[index], link: response.data.getFile.fileUrl };
                        }
                    }
                })
            ).then(() => {
                this.setState({ filesItem: itemsCopy }); 
            });
        }
    }
            
    
    getPathData(path){
        this.setState((prevState) => ({
            urlPath: path
          }));
    }
    resetFilesItem() {
        // const { items } = this.props; // Extract items from props
        this.setState({
            filesItem: [] ,// Create a copy of items to avoid direct mutation
            urlPath:""
        });
    }

    increaseMaxFiles() {
        let currentMaxFiles = this.state.currentMaxFiles;
        const maxFiles = this.props.maxFilesAmount;

        if (currentMaxFiles + 1 <= maxFiles)
            this.setState({currentMaxFiles: currentMaxFiles + 1});
    }

    render() {
        const {data, items, handleChangeFile, viewMode, deleted, disabled, classNames, maxFilesAmount, canUploadManually, handleChangeInput} = this.props;
        const currentMaxFiles = this.state.currentMaxFiles;
        const uploadManually = this.state.uploadManually;
        const fileType = this.props.fileType ? this.props.fileType : fileTypes.Document;

        return (
            <React.Fragment>
                {
                    this.state.filesItem.map((item,index) => {
                        if (index < currentMaxFiles)
                            return (
                                <UploadFile
                                    data={data}
                                    className={classNames}
                                    key={item.name}
                                    label={item.label}
                                    name={item.name}
                                    link={data[item.name]}
                                    disabled={disabled}
                                    deleted={deleted}
                                    viewMode={viewMode}
                                    handleChange={handleChangeFile}
                                    fileType={fileType}
                                    uploadManually={uploadManually}
                                    handleChangeInput={handleChangeInput}
                                    path={item.link || this.state.urlPath}
                                    resetFilesItem={this.resetFilesItem}
                                    getPathData={this.getPathData}
                                />
                            );
                    })
                }
                {
                    currentMaxFiles < maxFilesAmount && !viewMode &&
                    <button
                        type='button'
                        className='button-new positive'
                        onClick={this.increaseMaxFiles}>
                        Add {fileType === fileTypes.Photo ? 'photo' : 'file'}
                    </button>
                }
                {
                    !viewMode && canUploadManually &&
                    <button
                        type='button'
                        className='button-new positive upload-type'
                        onClick={() => this.setState({uploadManually: !this.state.uploadManually})}>
                        Upload {uploadManually ? 'File' : 'Manually'}
                    </button>
                }
            </React.Fragment>
        );
    }
}
     